// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_tb-0";
export var checkoutRateBadgeLink = "_tb-1";